import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LteMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lte_mobiledata"}/>
}
